/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: mojmir.studenovsky@eurowag.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum UnitCodeWeight {
    Ton = 'ton'
}

export function UnitCodeWeightFromJSON(json: any): UnitCodeWeight {
    return UnitCodeWeightFromJSONTyped(json, false);
}

export function UnitCodeWeightFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitCodeWeight {
    return json as UnitCodeWeight;
}

export function UnitCodeWeightToJSON(value?: UnitCodeWeight | null): any {
    return value as any;
}

